import React from 'react'
import styles from './styles.css'
import gql from 'graphql-tag'
import PropTypes from 'prop-types'
import ContractImage from 'App/components/ContractImage'
import Field from './Field'

export default class Page extends React.Component {
  static propTypes = {
    document: PropTypes.object,
    page: PropTypes.object,
    fields: PropTypes.array,
    setFieldValue: PropTypes.func,
    fieldsValues: PropTypes.object,
    sign: PropTypes.bool
  }

  static fragment = gql`
    fragment signDocumentPage on Document {
      pages {
        url
        index
        width
        height
      }
      ...signDocumentField
    }
    ${Field.fragment}
  `

  state = {}

  componentDidMount() {
    const height = this.reference.clientWidth * this.props.page.height / this.props.page.width
    this.setState({height})
  }

  renderFields() {
    if (!this.state.height) return
    return this.props.fields.map(field => {
      return (
        <Field
          key={field.id}
          field={field}
          document={this.props.document}
          type={field.type}
          height={this.state.height}
          page={this.props.page}
          onChange={value => this.props.setFieldValue(field.id, value)}
          value={
            field.type === 'text'
              ? {text: this.props.fieldsValues[field.id]}
              : field.type === 'checkbox'
                ? {checked: this.props.fieldsValues[field.id]}
                : this.props.fieldsValues[field.id]
          }
          sign={this.props.sign}
        />
      )
    })
  }

  render() {
    return (
      <div className={styles.container}>
        <div
          ref={reference => {
            this.reference = reference
          }}
        />
        <ContractImage height={this.state.height} page={this.props.page} />
        {this.renderFields()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/Document/Page/index.js